import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from './core/components/error/error.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AutoLoginComponent } from './auto-login/auto-login.component';

const routes: Routes = [
  { 
    path: 'autologin/:loginData', 
    component : AutoLoginComponent
  },
  { 
    path: '', 
    loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule),
    canActivate:[AuthGuard] 
  },
  {
    path: '**',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
